export default function debounce<Args extends unknown[]>(fn: (...args: Args) => void, wait = 50) {
  let timeoutId: ReturnType<typeof setTimeout> | undefined
  return (...args: Args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn(...args), wait)
  }
}
